import React, { useState, useRef, useEffect } from 'react';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import ReactApexChart from 'react-apexcharts';

import { fetchChartData } from '../../../services/client/dashBoardApiService'; 

ChartJS.register(ArcElement, Tooltip, Legend);

export function SourceChart({ month }) {

  const [data, setData] = useState({}); // Initialize data as an object
  const [loading, setLoading] = useState(true); // Track loading state

  useEffect(() => {
    // This function fetches the data when the month changes
    const fetchChartData1 = async () => {
      setLoading(true); // Set loading to true when data is being fetched
      try {
        const response = await fetchChartData(month); // Fetch data for the selected month
        setData(response); // Assuming the response is an object where keys are labels and values are series
      } catch (err) {
        console.log('Failed to fetch data:', err);
      } finally {
        setLoading(false); // Set loading to false once data is fetched
      }
    };

    fetchChartData1(); // Call the fetch function when month changes
  }, [month]); // The hook runs when the month prop changes

  // Extract series and labels from the fetched data
  const series = Object.values(data); // Convert data object values to an array (for the chart series)
  const labels = Object.keys(data);  // Convert data object keys to an array (for the chart labels)

  const options = {
    chart: {
      type: 'donut',
      width: '100%',
      height: '100%',
    },
    labels: labels,
    maintainAspectRatio: false,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: '100%',
            height: '100%',
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    legend: {
      position: 'bottom',
      floating: false,
      fontSize: '12px',
    },
    dataLabels: {
      enabled: true,
    },
    colors: ['rgb(64, 81, 137)', 'rgb(10, 179, 156)', 'rgb(247, 184, 75)', 'rgb(240, 101, 72)', 'rgb(41, 156, 219)'],
    plotOptions: {
      pie: {
        donut: {
          size: '60%',
        },
        expandOnClick: true,
        dataLabels: {
          offset: -1,
        },
      },
    },
    stroke: {
      show: false,
    },
  };

  // Render the loading state or the chart depending on the loading state
  if (loading) {
    return <div>Loading...</div>; // Simple loading text, could be a spinner
  }

  return (
    <div className='text-center w-full h-full items-center'>
      {options? (
      <ReactApexChart options={options} series={series} type="donut" />
    ):'No Data'}
    </div>
  );
}
